module.exports = __webpack_public_path__ + "img/plan_renew.3bc19196.png";